import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { List } from 'material-ui/List';
import { UserCreateListItem, UserListItem } from '@molecules';
import { Container, ListContainer } from './layout';

export default class UserList extends Component {
  static propTypes = {
    users: PropTypes.arrayOf(
      PropTypes.shape({
        username: PropTypes.string,
        email: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
      }),
    ).isRequired,
    isLoading: PropTypes.bool.isRequired,
    loadUsers: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.loadUsers();
  }

  render() {
    const { users } = this.props;
    return (
      <Container>
        <ListContainer>
          <List>
            <UserCreateListItem key="create-user" />
            {users.map((user) => (
              <UserListItem key={user.id} {...user} />
            ))}
          </List>
        </ListContainer>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./components/organisms/UserList/UserList.js